module.exports = "/images/1c9468daa126a6cc9d54476967247850.svg";